<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-18 17:52:50
 * @LastEditors: lau
 * @LastEditTime: 2022-08-18 17:56:04
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-18 17:27:47
 * @LastEditors: lau
 * @LastEditTime: 2022-08-18 17:30:02
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-18 16:03:56
 * @LastEditors: lau
 * @LastEditTime: 2022-08-18 17:22:53
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-18 15:17:10
 * @LastEditors: lau
 * @LastEditTime: 2022-08-18 15:27:14
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-18 14:24:52
 * @LastEditors: lau
 * @LastEditTime: 2022-08-18 14:47:28
-->
<!-- 查询线上月票接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
  
            },
            responseCode: {
                
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台根据授权ID取消月票访客授权",
                t_url: this.commonUrls.test + "cancelMonthTicketAuthorizeVisitorByCarNo",
                p_url: this.commonUrls.prod + "cancelMonthTicketAuthorizeVisitorByCarNo",
                precondition: "无",
                fitSystem: "云停车场，传统停车场（线上开通的月票）",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'Long', info4: '车场编号' },
                        { info1: 'carCode', info2: '是', info3: 'Long', info4: '授权车牌号码' },
                        { info1: 'enterTime', info2: '是', info3: 'Long', info4: '进场时间yyyyMMddHHmmss' },
                        { info1: 'operator', info2: '否', info3: 'String', info4: '操作人' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        // { info1: 'id', info2: '是', info3: 'Long', info4: '月票凭证id' },

					   ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/cancelMonthTicketAuthorizeVisitorByCarNo.vue